/**
 * Store Model - Processes API responses for store data
 */

/**
 * Process store list response data
 * @param {Object} response - API response from store list endpoint
 * @returns {Object} Formatted store list data
 */
export const storeListGet = (response) => {
    // Based on Postman collection response format
    if (response && response.data && response.data.success === true) {
        return {
            success: true,
            total: response.data.total || response.data.data.length,
            data: response.data.data
        };
    }
    return {
        success: false,
        message: response?.data?.message || 'Failed to fetch store list',
        data: []
    };
};